<h2 mat-dialog-title>Add Pool Point Store</h2>
<mat-dialog-content>
    <form [formGroup]="storeForm" (ngSubmit)="submit()">
        <mat-form-field>
            <mat-label>Pool Point Store Number</mat-label>
            <input matInput formControlName="pool_point_store_number">
        </mat-form-field>
        <app-contact-autocomplete
            placeholder="Search contacts..." 
            [type]="'consignee_contact_list'" 
            [formControl]="poolPointStoreContactControl" 
            (selected)="onStoreSelected($event)"
        ></app-contact-autocomplete>
        <mat-form-field appearance="outline" color="primary">
            <mat-label>Pool Point Store Address</mat-label>
            <mat-select formControlName="pool_point_store_address_uuid">
                <mat-option *ngFor="let address of storeAddressOptions" [value]="address.value">{{address.label}}</mat-option>
            </mat-select>
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-action-list>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-raised-button (click)="submit()" color="primary">Submit</button>
</mat-action-list>